import { useState } from 'react'
import axios from 'axios'
import { useAuthHeader } from 'react-auth-kit'
import Button from '../../usables/small/ButtonReal'

export default function FileUpload({ labelText, apiURI, fileFormat }) {
  const auth  = useAuthHeader()
  const [selectedFile, setSelectedFile] = useState(null)

  const handleSubmit = async (event) => {
    event.preventDefault()
    const formData = new FormData()
    formData.append('selectedFile', selectedFile)
    try {
      const response = await axios({
        method: 'post',
        url: apiURI,
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data',
                    Authorization: auth() },
      })
      console.log(response)
      window.location.reload()
    } catch(error) {
      console.log(error)
    }
  }

  const handleFileSelect = (event) => {
    setSelectedFile(event.target.files[0])
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className='mb-3 w-96'>
        <label htmlFor='formFile' className='form-label inline-block mb-2 text-gray-700'>{labelText}</label>
        <input type='file' accept={fileFormat} className='form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 roundedtransition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-violet-600 focus:outline-none' id='formFile' onChange={handleFileSelect}/>
      </div>
      <Button type='submit' text='Įkelti' />
    </form>
  )
}

FileUpload.defaultProps = {
  labelText: 'Failo įkėlimas',
  apiURI: '/api/upload/file',
  fileFormat: '.csv, .txt'
}